// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_eu-a";
export var fulfillmentFormRail = "_eu-9";
export var headerTitleRow = "_eu-c";
export var orderDetailsWrapper = "_eu-7";
export var orderLinkTrigger = "_eu-2";
export var paymentInformationGrid = "_eu-h";
export var paymentSummaryColumn = "_eu-i";
export var shipmentContainer = "_eu-b";
export var shipmentDetailsMainPane = "_eu-8";
export var shipmentNavigationCard = "_eu-5";
export var shipmentNavigationRail = "_eu-3";
export var shipmentNavigationRailHeader = "_eu-4";
export var shipmentSummaryFact = "_eu-e";
export var shipmentSummaryGrid = "_eu-d";
export var shipmentSummaryMetadataRow = "_eu-f";
export var shipmentSummaryTags = "_eu-g";
export var shipmentWorkspace = "_eu-0";
export var shipmentWorkspaceContent = "_eu-6";
export var shipmentWorkspaceHeader = "_eu-1";